import { v4 as uuidv4 } from 'uuid';

export function ProductSpecificationGroup(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductSpecificationGroup',
		componentId: uuidv4(),
		props: Object.assign({}, props),
		childrenComponents,
	};
}
